<div
	class="activity-task-sessions"
	[class.activity-task-sessions--editor-context]="isEditorContextMode">
	@if ((currentView$ | async); as currentView) {
		@let taskType = taskType$ | async;
		@let hasSessions = hasFilteredSessions$ | async;
		@let filteredSessions = filteredSessions$ | async;
		@let canInviteLearners = isEditorContextMode ? false : canInvite();
		@if (taskType) {
			@if (taskType === TaskType.Evaluate) {
				<div class="submissions-header">
					<h1 id="unscored-title">{{ 'common_submissions' | translate }}</h1>
					<ngx-overview-navigation
						[showInviteButton]="hasSessions && canInviteLearners && !isGroupActivity()">
					</ngx-overview-navigation>
				</div>
			}

			@if (shouldShowTaskTopSection(taskType)) {
				<div id="task-top-section">
					@if (taskType === TaskType.Evaluate) {
						@if(scoredActivity()) {
							<button
								(click)="setScoredFilter(ScoreFilter.NO_SCORE)"
								id="unscored-filter"
								class="score-tab"
								[class.active]="(scoredFilter$ | async) === ScoreFilter.NO_SCORE">
								<span>{{ 'common_unscored' | translate }}</span>
							</button>
							<button
								(click)="setScoredFilter(ScoreFilter.SCORED)"
								id="scored-filter"
								class="score-tab"
								[class.active]="(scoredFilter$ | async) === ScoreFilter.SCORED">
								<span>{{ 'common_scored' | translate }}</span>
							</button>
						}
					} @else {
							<task-details
								[task]="task"
								[totalTasks]="totalTaskCount"
								[currentTaskIndex]="currentTaskPosition"
								[previousButtonLabelKey]="getTaskNavigatorBackLabelKey()"
								(navigateBack)="onNavigateBack()"
								(navigateForward)="onNavigateForward()"
								(openNavigator)="onOpenNavigator()">
						</task-details>
					}
				</div>
			}
			@if (shouldShowTaskDetailsSubtitle()) {
				<h2 class="task-details-subtitle">{{ taskDetailsSubtitle() | translate }}</h2>
			}
		}

		@if (shouldShowPresentTaskAdditionalSettings()) {
			<present-task-additional-settings
				(tasksUpdated)="onTasksUpdated($event)">
			</present-task-additional-settings>
		} @else if (shouldShowReactAdditionalSettings()) {
			<react-task-additional-settings />
		} @else if (!isEditorContextMode) {
			<div class="tools-mobile">
				<session-list-search-result-info [filteredSessions]="filteredSessions"></session-list-search-result-info>
				<session-search></session-search>
			</div>
			<filter-view-layout
				id="activity-view-container"
				class="layout"
				#activityContainer>
				<div class="filter-bar" filter-view-filter-bar [hidden]="dataSourceZeroState.hasZeroState && dataSourceZeroState.errorCode !== 0">
					<div class="filter-view" [formGroup]="form">
						<div class="sort-container">
							<mat-form-field goSelect>
								<mat-label>{{ 'common_sort-by' | translate }}</mat-label>
								<mat-select
									formControlName="sortBy"
									disableOptionCentering
									panelClass="offsetPanel">
									@for (option of sortByOptions; track option) {
										<mat-option
											[value]="option">
											{{ sortOrderTranslations[option] | translate }}
										</mat-option>
									}
								</mat-select>
								<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
							</mat-form-field>
						</div>
						@if (shouldShowFeedbackHold()) {
							<feedback-hold class="mobile-only"></feedback-hold>
						}
					</div>
					<div class="tools-desktop-tablet" [class.no-feedback-hold]="!shouldShowFeedbackHold()">
						@if (shouldShowFeedbackHold()) {
							<feedback-hold></feedback-hold>
						}
						<div class="search-container">
							<session-list-search-result-info [filteredSessions]="filteredSessions"></session-list-search-result-info>
							<session-search></session-search>
						</div>
					</div>

				</div>

				<div class="filter-option"
					[class.no-feedback-hold]="hasPresenterRole() || !shouldShowFeedbackHold()"
					filter-view-options-bar
					[hidden]="dataSourceZeroState.hasZeroState">
					<div class="search-container">
						<session-list-search-result-info [filteredSessions]="filteredSessions"></session-list-search-result-info>
						<session-search></session-search>
					</div>
					<toggle-grid-list-view></toggle-grid-list-view>
				</div>

				@if (!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading) {
					<div class="filter-content"
						filter-view-content
						(contextmenu)="openMenu($event)">
						@if (hasSessions) {
							@if ((shouldShowTestBailedView$ | async) !== true) {
								@let filteredSessions = filteredSessions$ | async;
								@if (currentView === views.LIST) {
									<div class="list-view">
										<session-table
											[submitMode]="taskType === TaskType.Submit"
											[allowSelection]="shouldAllowSessionSelection((hasSubmittedSessions$ | async) ?? false)"
											[selectedSessionIds]="selectedSessionIds$ | async"
											(selectionToggled)="onSessionSelectionToggled($event)"
											[isSubmittingSessions]="isSubmittingSessions"
											[sessions]="filteredSessions"
											(goToSession)="openSession($event)">
										</session-table>
									</div>
								}
								@if (currentView === views.GRID) {
									<div class="grid-view">
										<session-grid
											[submitMode]="taskType === TaskType.Submit"
											[allowSelection]="shouldAllowSessionSelection((hasSubmittedSessions$ | async) ?? false)"
											[selectedSessionIds]="selectedSessionIds$ | async"
											(selectionToggled)="onSessionSelectionToggled($event)"
											[isSubmittingSessions]="isSubmittingSessions"
											[filteredSessions]="filteredSessions"
											(openSession)="openSession($event)">
										</session-grid>
									</div>
								}
							} @else {
								<ngx-zero-state class="zero-state-single-attempt-activity" data-cy="bailed-test">
									<p zero-state-title translate="session-list_zero-state-bailed-test-title"></p>
									<p zero-state-subtext translate="session-list_zero-state-bailed-test-subtext"></p>
								</ngx-zero-state>
							}
						} @else {
							<session-zero-state
								[noVideosTitleKey]="getNoVideosTitleKey()"
								[noVideosSubtextKey]="getNoVideosSubtextKey()"
								[noVideosSubtextParams]="getNoVideosSubtextParams()"
								[showFilteredZeroState]="taskType !== TaskType.Evaluate"
								[showInviteButton]="taskType === TaskType.Evaluate && canInviteLearners"
								[showCreateVideoButton]="taskType === TaskType.Evaluate && isGroupActivity()"
								[showLearnerZeroState]="taskType === TaskType.Present && isGroupActivity()"
								[learnFromFeedbackState]="learnFromFeedbackZeroState$ | async"
								(startActivity)="preStartActivity()"
								[taskType]="taskType"
								(viewInstructions)="viewInstructions()"
								(inviteLearners)="openInviteModal()">
							</session-zero-state>
						}

						@if ((canStartActivity$$ | async) && !isConversationBoard()) {
							<menu>
								<activity-context-menu
									(viewInstructions)="viewInstructions()"
									[canStartActivity]="canStartActivity$$ | async"
									(onStartActivity)="preStartActivity()"></activity-context-menu>
							</menu>
						}
					</div>
				}

				<!-- Datasource zero state -->
				<div class="filter-zero-state" filter-view-content [hidden]="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading">
					<data-source-zero-state [dataSource]="sessionListDataSource" (zeroStateChanged)="zeroStateChanged($event)"></data-source-zero-state>
				</div>

				<div class="filter-action"
					filter-view-action-bar
					[hidden]="dataSourceZeroState.hasZeroState || (taskType === TaskType.Evaluate && !isGroupActivity())">
					@if (shouldShowFooterButtons$ | async) {
						@if (taskType !== TaskType.Submit && !isActivityTasksEnabled) {
							<button
								class="link-btn view-instructions-btn"
								(click)="viewInstructions()"
								[attr.aria-label]="'session-zero-state_view_instructions' | translate">
								<span class="regular">{{ 'session-zero-state_view_instructions' | translate }}</span>
								<span class="shortened">{{ 'session-zero-state_view_instructions_shortened' | translate}}</span>
							</button>
						}
						@if (canInvite()) {
							<button
								class="secondary-btn invite-btn"
								(click)="openInviteModal()"
								[translate]="isGroupActivity() ? 'activity-report_invite-learners' : 'common_invite'"
								[attr.aria-label]="(isGroupActivity() ? 'activity-report_invite-learners-aria' : 'common_invite') | translate">
							</button>
						}
						@if (!isConversationBoard() && taskType !== TaskType.Submit && taskType !== TaskType.React) {
							<span>
								<button
									class="btn start-activity-btn"
									[class.secondary-btn]="isActivityTasksEnabled && !isGroupActivity()"
									[class.primary-btn]="!isActivityTasksEnabled || isGroupActivity()"
									data-cy="add-video"
									(click)="preStartActivity()"
									[disabled]="(canStartActivity$$ | async) === false"
									disabledInteractive
									[matTooltip]="getSessionCreationDisabledMessage$$ | async"
									[matTooltipDisabled]="canStartActivity$$ | async"
									matTooltipPosition="above"
									[attr.aria-label]="getStartActivityButtonAriaLabelKey() | translate">
									<span class="regular">{{ getStartActivityButtonTextKey() | translate }}</span>
									<span class="shortened">{{ getStartActivityButtonShortenedTextKey() | translate }}</span>
								</button>
							</span>
						}
						@if (taskType === TaskType.Submit) {
							@if (((hasSubmittedSessions$ | async) ?? false) === true) {
								@if (isEditingSubmission) {
									<button
										type="button"
										class="btn tertiary-btn cancel-edit-submission-btn"
										(click)="cancelEditSubmissionMode()"
										[disabled]="isSubmittingSessions">
										{{ 'common_cancel' | translate }}
									</button>

									<button
										type="button"
										class="btn primary-btn submit-task-btn"
										(click)="submitSelectedSessions()"
										[disabled]="isSubmittingSessions">
										@if (isSubmittingSessions) {
											<i class="ficon-spinner ficon-spin" aria-hidden="true"></i>
										}
										{{ 'common_save' | translate }}
									</button>
								} @else {
									<button
										disabledInteractive
										type="button"
										class="btn secondary-btn edit-submission-btn"
										[disabled]="isReadOnly()"
										(click)="enterEditSubmissionMode()">
										{{ 'session-editor-panel_edit-submission' | translate }}
									</button>
								}
							} @else {
								<button
									type="button"
									class="btn primary-btn submit-task-btn"
									data-cy="submit-task-btn"
									(click)="submitSelectedSessions()"
									[matTooltip]="'session-editor-panel_disabled-submit-btn-tooltip' | translate"
									[matTooltipDisabled]="hasSelectedSessions"
									[disabled]="isSubmittingSessions"
									disabledInteractive>
									@if (isSubmittingSessions) {
										<i class="ficon-spinner ficon-spin" aria-hidden="true"></i>
									}
									{{ 'common_submit' | translate }}
								</button>
							}
						}
					}
				</div>
			</filter-view-layout>
		}
	}
</div>
